import { combineReducers } from 'redux';
import contactChannels from './reducer-contact-channels';
import query from './reducer-query-params';
import notifier from './reducer-notifier';
import emailForm from './reducer-email-form';
import emailNoIntent from './reducer-email-form-no-intent';
import breadCrumb from './reducer-breadcrumb-items';
import activeCommunityUserCount from './reducer-active-community-user';
import faqId from './reducer-faq';
import topicTree from './reducer-message-topic-tree';
import topicSelect from './reducer-select-topics';
import selectResult from './reducer-topic-select-result';
import activeArticle from './reducer-active-article';
import modal from './reducer-login-modal';
import callUs from './reducer-call-us';
import errors from './reducer-error';
import autoComplete from './reducer-auto-complete';
import searchResult from '../../home/reducers/reducer-search-results';
import helpcenterAlerts from './reducer-helpcenter-alerts';
import chat from './reducer-chat-eligibility';
import user from './reducer-locale';
import location from './reducer-location';
import quickAnswers from './reducer-quick-answers';
import suggestTopics from './reducer-related-topic';
import PPCredit from './reducer-ppc-enable';
import * as constant from '../constants/ActionTypes';


const appReducer = combineReducers({
  contactChannels,
  query,
  notifier,
  searchResult,
  breadCrumb,
  emailForm,
  emailNoIntent,
  activeCommunityUserCount,
  activeArticle,
  faqId,
  topicTree,
  topicSelect,
  selectResult,
  callUs,
  errors,
  autoComplete,
  helpcenterAlerts,
  modal,
  user,
  chat,
  location,
  quickAnswers,
  suggestTopics,
  PPCredit,
});

const rootReducers = (state, action) => {
  if (action.type === constant.LOGOUT || action.type === constant.LOCALE_CHANGED) {
    state = undefined; // eslint-disable-line no-param-reassign
  }
  return appReducer(state, action);
};
export default rootReducers;
